import { For, Show } from 'solid-js';
import ItemStackView from './ItemStackView';
import { useCraftingResolver } from '../services/craftingResolverContext';
import { resolveItemDisplayName } from '../services/itemDisplayName';
import { formatQuantity } from '../services/quantityFormatter';
import { useTranslation } from '../hooks/useTranslation';
import type { SellbotReasonItem } from '../services/sellbotReasonItems';

interface SellbotReasonItemsProps {
    items: SellbotReasonItem[];
    size?: number;
    showNames?: boolean;
}

export default function SellbotReasonItems(props: SellbotReasonItemsProps) {
    const resolver = useCraftingResolver();

    const { t } = useTranslation();

    const itemLabel = (entry: SellbotReasonItem) =>
        resolveItemDisplayName(entry.stack, resolver());


    return (
        <Show when={props.showNames !== false} fallback={
            <span class="h hcenter" style={{ gap: 'var(--spacing-xs)', 'flex-wrap': 'wrap' }}>
                <For each={props.items}>{(entry) => (
                    <ItemStackView stack={entry.stack} size={props.size ?? 20} showTooltip showCount={false} />
                )}</For>
            </span>
        }>
            <div class="v" style={{ gap: 'var(--spacing-xs)' }}>
                <For each={props.items}>{(entry) => (
                    <span class="h hcenter" style={{ gap: 'var(--spacing-sm)' }}>
                        <ItemStackView stack={entry.stack} size={props.size} showTooltip showCount={false} />
                        <span class="v">
                            <span>{itemLabel(entry)} ×{formatQuantity(entry.count, resolver()?.getItem(entry.itemKey)?.stackSize)}</span>
                            <Show when={entry.pickedUpBy !== undefined}>
                                <span style={{ 'font-size': 'var(--font-size-xs)', color: 'var(--dark-text-muted)' }}>
                                    {entry.pickedUpBy ? t('SELLBOT_ITEM_PICKED_UP_BY', entry.pickedUpBy) : t('SELLBOT_ITEM_PICKED_UP_UNKNOWN')}
                                </span>
                            </Show>
                        </span>
                    </span>
                )}</For>
            </div>
        </Show>
    );
}
